const ABTestsReducerInitialState = [
  'DGS-1234-placeholder-test' // Keep this if no other AB tests are in this array.
];

export default ABTestsReducerInitialState;
